import { MutationObserver, MutationScope } from '@tanstack/react-query';
import { reactQueryClient } from '../../web/ReactQueryProvider';

// PATCH /template/{id} is last-write-wins. A scope runs its mutations one at a time in the order started, retries
// included, so the last save of a template started is the last to land.
export function templateSaveScope(templateId: string): MutationScope {
	return { id: `template-save:${templateId}` };
}

/** Runs a save made outside React Query (the MobX TemplatesViewModel) in the template's save scope */
export function runInTemplateSaveScope<T>(templateId: string | undefined, save: () => Promise<T>): Promise<T> {
	if (!templateId) {
		return save();
	}
	return new MutationObserver<T, unknown, void>(reactQueryClient, {
		mutationFn: save,
		// 'online' pauses a mutation while offline, and a paused mutation blocks its whole scope
		networkMode: 'always',
		scope: templateSaveScope(templateId),
	}).mutate();
}
